module.exports = __webpack_public_path__ + "static/media/report_issue-icon.20da19ba.svg";